import axios from "axios"
import { COMPANIES_ENDPOINT, UPDATE_COMPANIES_LABEL } from "../../../../../utility/SourceAPI"

export const fetchCompanies = async () => {
    const response = await axios.get(COMPANIES_ENDPOINT)
    return response.data
}

export const fetchCompaniesTracking = async () => {
    const response = await axios.get(COMPANIES_ENDPOINT.concat("?is_application_tracking=false"))
    return response.data
}

export const fetchCompaniesTM = async () => {
    const response = await axios.get(COMPANIES_ENDPOINT.concat("?have_tm=false"))
    return response.data
}

export const updateCompany = async (companyRFC, companyData) => {
    const response = await axios.put(`${COMPANIES_ENDPOINT}rfc/${companyRFC}`, companyData)
    return response.data
}

export const updateCompanyLabel = async (companyRFC, labelData) => {
    const response = await axios.put(`${UPDATE_COMPANIES_LABEL}${companyRFC}`, labelData)
    return response.data
}

export const updateCompanyStatus = async (companyRFC, statusData) => {
    const response = await axios.put(`${COMPANIES_ENDPOINT}status/${companyRFC}`, statusData)
    return response.data
}

export const updateCompanyStartEndDate = async (companyRFC, startEndDateData) => {
    const response = await axios.put(COMPANIES_ENDPOINT.concat(`dates/${companyRFC}`), startEndDateData)
    return response.data
}
